<div class="menu-btn" 
[ngClass]="{'show-menu-btn': scrollHeight.value>0}" (click)="toggelMenu()">
 
  <fa-icon [icon]="['fas', 'bars']"></fa-icon>
</div>
<div class="moving-menu" (click)="toggelMenu()" [ngClass]="{'moving-menu-ac': activateMovingMenu, 'moving-menu-nac': !activateMovingMenu && !isFirstLoadMenu}">
  <div class="social-network-links">
    <div class="social-network-link">
      <a href="https://www.instagram.com/archonline.co.il/" target="blank">
          <div class="instagram"></div>
      </a>
    </div>
    <div class="social-network-link">
        <a href="https://www.facebook.com/gilarchonline/" target="blank">
            <div class="facebook"></div>
        </a>
      </div>
  </div>
 
  <div class="moving-menu-row" >
      <a  class="moving-menu-item-link" 
      routerLink="/">דף הבית</a>
     
  </div>

  <div class="moving-menu-row" *ngFor="let menuItem of menuItems">
      <a  class="moving-menu-item-link" *ngIf="menuItem.id!=1 || productList.length==0" 
      routerLink="{{menuItem.link}}">{{menuItem.title}}</a>
     <div class="moving-menu-item-link" *ngIf="menuItem.id==1 && productList.length>0" >
       <div class="moving-menu-item-link-open-list-txt-wrapper" (click)="showProductList()">

       
       <div class="moving-menu-item-link-open-list-txt">{{menuItem.title}} </div>
       <div  *ngIf="!displayProductList && productList.length>0" class="moving-menu-item-link-open-list-icon">
          <fa-icon [icon]="['fas', 'angle-down']" ></fa-icon>
        </div>
        <div  *ngIf="displayProductList" class="moving-menu-item-link-open-list-icon">
            <fa-icon [icon]="['fas', 'angle-up']" ></fa-icon>
          </div>
       </div>
       <div *ngIf="displayProductList">
          <div *ngFor="let product of productList"
          class="moving-menu-item-link-open-list-row" 
          routerLink="/p/product/{{product.Id}}/{{product.Name | StringToUrl}}"
          >
          - {{product.Name}}
          </div>
          <div class="moving-menu-item-link-open-list-row" (click)="toggelEscort()">- ליווי אדריכלי צמוד</div>
       </div>
       
     </div>
  </div>
  <div class="moving-menu-row">
      <a class="moving-menu-item-link moving-menu-link-studio" 
      href="http://gilarch.co.il/">סטודיו גיל אדריכלות</a>
  </div>
  
  
</div>
<app-arch-escort *ngIf="displayEscortWindow" (toggelEscourt)="toggelEscort()"></app-arch-escort>
